/** 落地页 AI 服务商快照 → 运营可读名称；审核记录、脱敏日志与项目执行共用，历史缺省值按 OpenRouter 展示。 */
import type { LandingAiProvider } from '@novel-admin/shared';

const LABELS: Record<LandingAiProvider, string> = {
  openrouter: 'OpenRouter',
  bailian: '百炼',
  ollama: 'Ollama',
  huggingface: 'Hugging Face',
};

/** 未知值原样展示（前后端版本错配时不显示 undefined）。 */
export function landingAiProviderLabel(provider: string | null | undefined): string {
  if (!provider) return LABELS.openrouter;
  return LABELS[provider as LandingAiProvider] ?? provider;
}
